import { send } from '../../../../../../../src/network';
import { type CustomerPairingRatingDetail } from '../../../../../../../src/types/CustomerPairingRatingDetail';
import { type PatchedCustomerPairingRatingDetail } from '../../../../../../../src/types/PatchedCustomerPairingRatingDetail';

type Params = {
  customerId: number;
  pairingId: number;
  requestBody: PatchedCustomerPairingRatingDetail;
};

export async function patchApiV2CustomersCustomerIdPairingRatingsPairingId({
  customerId,
  pairingId,
  requestBody,
}: Params) {
  return await send<CustomerPairingRatingDetail>({
    path: `/api/v2/customers/${customerId}/pairing_ratings/${pairingId}/`,
    method: 'PATCH',
    body: requestBody,
  });
}
